import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const addFeedbackForm = async (id, params) => {
  return await axios.post(`${baseURL}/feedback-form/${id}`, params);
};

export const getFeedbackForm = async (id) => {
  const params = { unitOfferId: id };
  return await axios.get(`${baseURL}/feedback-form`, { params });
};

export const updateFeedbackForm = async (id, params) => {
  return await axios.put(`${baseURL}/feedback-form/${id}`, params);
};

export const updateFeedbackFormBySurveyId = async (surveyId, params) => {
  return await axios.put(`${baseURL}/feedback/${surveyId}`, params);
};

export const addFeedbackTemplate = async (params) => {
  return await axios.post(`${baseURL}/feedback-skeleton`, params);
};

export const getFeedbackTemplates = async (params) => {
  return await axios.get(`${baseURL}/feedback-skeleton`, { params });
};

export const updateFeedbackTemplate = async (id, params) => {
  return await axios.put(`${baseURL}/feedback-skeleton/${id}`, params);
};

export const addQuestion = async (params) => {
  return await axios.post(`${baseURL}/questions`, params);
};

export const getQuestions = async (params) => {
  return await axios.get(`${baseURL}/questions`, { params });
};

export const updateQuestion = async (id, params) => {
  return await axios.put(`${baseURL}/question/${id}`, params);
};
